export default __webpack_public_path__ + "static/media/scooterLocked.f5b8d587.svg";